import { useState } from "react";
import { Button, Checkbox } from "react-aria-components";
import ChevronDown from "src/design-system/icons/ChevronDown.svg?react";
import ChevronUp from "src/design-system/icons/ChevronUp.svg?react";
import Check from "src/design-system/icons/Check.svg?react";
import { useBackendFlags } from "../../utils/hooks/useBackendFlags";

export function BackendFlagSelector() {
  const {
    addBackendFlag,
    removeBackendFlag,
    getBackendFlagValue,
    backendFlagsOptions,
  } = useBackendFlags();

  const setbackendFlagsParam = (
    featureName: string,
    value: boolean | undefined,
  ) => {
    if (value) {
      addBackendFlag(featureName);
    } else {
      removeBackendFlag(featureName);
    }
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    if (isExpanded) setIsExpanded(false);
    else setIsExpanded(true);
  };

  return (
    <>
      <Button
        className="flex w-full cursor-pointer items-center justify-between p-4 text-left text-sm 2xl:w-100"
        onPress={toggleExpand}
      >
        <h3>Backend Flags</h3>
        {!isExpanded ? <ChevronDown /> : <ChevronUp />}
      </Button>

      {isExpanded &&
        backendFlagsOptions.map((backendFeature) => {
          const value = getBackendFlagValue(backendFeature);

          const onCheckboxChange = (isSelected: boolean) => {
            setbackendFlagsParam(backendFeature, isSelected);
          };

          return (
            <div
              className="flex w-full items-center justify-between p-4 text-left text-sm 2xl:w-100"
              key={backendFeature}
            >
              <label className="flex-grow-2" htmlFor={backendFeature}>
                {backendFeature}
              </label>
              <Checkbox
                className="flex h-4.5 w-4.5 cursor-pointer items-center justify-center border-1 border-input-border"
                id={backendFeature}
                defaultSelected={value}
                onChange={onCheckboxChange}
              >
                {({ isSelected }) =>
                  isSelected && <Check className="h-3 w-3" />
                }
              </Checkbox>
            </div>
          );
        })}
    </>
  );
}
